import React from 'react';
import styles from './Setting.module.css';

const Customization = ({ theme, setTheme, language, setLanguage }) => {
  const toggleTheme = () => {
    setTheme(theme === 'light' ? 'dark' : 'light'); // Theme toggle
  };

  const handleLanguageChange = (event) => {
    setLanguage(event.target.value);  // Language change
  };

  const saveSettings = () => {
    // Yahan aap settings ko save kar sakte ho (localStorage ya API mein)
    console.log('Settings saved:', { theme, language });
    // Yahan console.log ko apni actual save logic se replace kar sakte hain
    alert('Settings have been saved');
  };

  return (
    <div className={styles.sectionContent}>
      <h3>Panel Customization</h3>

      {/* Theme Toggle */}
      <div className={styles.toggleContainer}>
        <label className={styles.switch}>
          <input
            type="checkbox"
            checked={theme === 'dark'}
            onChange={toggleTheme}  // Theme toggle
          />
          <span className={styles.slider}></span>
        </label>
        <div className={styles.themeLabel}>
          {theme === 'light' ? 'Light Mode' : 'Dark Mode'}
        </div>
      </div>

      {/* Language Selection */}
      <div className={styles.languageContainer}>
        <label htmlFor="language" className={styles.languageLabel}>Language:</label>
        <select
          id="language"
          value={language}
          onChange={handleLanguageChange}  // Language selection
          className={styles.languageSelect}
        >
          <option value="en">English</option>          
          <option value="hi">हिंदी</option>
          {/* Aur languages add kar sakte hain */}
        </select>
      </div>

      {/* Save Button */}
      <div className={styles.saveButtonContainer}>
        <button className={styles.saveButton} onClick={saveSettings}>Save</button>
      </div>
    </div>
  );
};

export default Customization;
